<div class="logo"></div>

<div class="message" [innerHTML]="message"></div>
